export const SHOTS = {
  command: { key: "command", src: "/screenshots/command-centre.png", title: "Command Centre",
    caption: "Today's exceptions, readiness scores and next actions across every job, one screen.",
    alt: "Fieldistry Command Centre dashboard showing jobs, readiness and exceptions" },
  schedule: { key: "schedule", src: "/screenshots/schedule.png", title: "Schedule & dispatch",
    caption: "Crews, techs and equipment on one calendar with conflict warnings.",
    alt: "Fieldistry schedule board with crew and equipment assignments" },
  jobs: { key: "jobs", src: "/screenshots/jobs.png", title: "Jobs",
    caption: "Every job with its stage, assigned crew, materials status and next action.",
    alt: "Fieldistry jobs list showing stages and next actions" },
  customers: { key: "customers", src: "/screenshots/customers.png", title: "Customer records",
    caption: "Full history per customer: quotes, jobs, sites, documents and messages.",
    alt: "Fieldistry customer records list" },
  myWork: { key: "my-work", src: "/screenshots/my-work.png", title: "My Work",
    caption: "Each person's day, prioritized, nobody asks 'what should I do next?'.",
    alt: "Fieldistry My Work personal home" },
  jobDetail: { key: "job-detail", src: "/screenshots/job-detail.png", title: "Job record",
    caption: "One record from first call to final payment, workflow, materials, schedule, money.",
    alt: "Fieldistry job detail with workflow, materials and schedule" },
  field: { key: "field", src: "/screenshots/field-my-day.png", title: "Field app, My Day",
    caption: "Crews run the day from their phone: checklists, photos, time, issues.",
    alt: "Fieldistry mobile field workspace My Day view" },
};
